import { CatalogSettingContext, SubscriptionModalContext, RouterCartContext } from "./chooseTreatmentContexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import SubscriptionModal from "../../components/Modals/SubscriptionModal/SubscriptionModal";
import * as http from "../../utils/http";
import * as translator from "../../utils/translator";
import ChooseTreatmentLandingPage from "./ChooseTreatmentLandingPage/ChooseTreatmentLandingPage";
import LoadingModal from "../../components/Modals/LoadingModal/LoadingModal";
import LoadingPage from "../Questionnaire/VariantB/LoadingPage";
import { getCartMention, getQuestionnaireMention } from "../../utils/funnelMentionRedirects";
import HeaderController from "../../components/Headers/HeaderController";
import ServerError from "../../components/ServerError/ServerError";
import FreeDosageLayoutV2 from "./FreeDosageChooseTreatmentV2/FreeDosageLayoutV2";
import FreeDosageLayoutV2Legacy from "./FreeDosageChooseTreatmentV2Legacy/FreeDosageLayoutV2";
import ReturningCustomersLayout from "./ReturningCustomersLayout/ReturningCustomersLayout";
import StickyNotification from "../../components/StickyNotification/StickyNotification";
import { useCartContext } from "../../customHooks/useCart";
import { CHOOSE_TREATMENT_PAGE_VIEW_EVENT, ORDER_FLOWS } from "../../utils/consts";
import CannaleoFreeDosageLayout from "./CannaleoFreeDosageChooseTreatment/CannaleoFreeDosageLayout";
import ChooseTreatmentCarePlusNew from "../ChooseTreatmentCarePlusNew/ChooseTreatmentCarePlusNew";
import * as SocialMediaTracker from "../../PixelTrackers/SocialMediaTracker";
import { MainTracker } from "../../PixelTrackers/MainTracker";
import { getSaveAnswerVariant } from "../../utils/saveQuestionnaireAnswersExperiment";
import { getWlExperimentTrackingProps } from "../../utils/wlCarePlusExperiment";
import { getFlowzzTrackingProps } from "../../utils/flowzzTracking";
import { assignOtcPopupVariant, setContinueToShippingCategory } from "../../utils/otcPopupExperiment";
import { assignDefaultProductVariant, clearDefaultProductTrackingProps, getDefaultProductTrackingProps } from "../../utils/defaultProductExperiment";
import { FLOWZZ, FLOWZZ_FAST_DOCTOR_APPROVAL_TEST_NAME, FLOWZZ_FAST_DOCTOR_APPROVAL_VARIANTS, SERVICE_FEE_TEST_NAME, SERVICE_FEE_VARIANTS } from "../../utils/consts";
import * as SessionStorageWrapper from "../../utils/SessionStorageWrapper";
import { triggerExperiment } from "../../PixelTrackers/KameleoonTracker";
import { useAppContext } from "../../providers/AppProvider";
export { CatalogSettingContext, SubscriptionModalContext, RouterCartContext } from "./chooseTreatmentContexts";

/**
 * HL-12814: Kameleoon variation name -> ticket arm. The experiment has two variations, "A" (original)
 * and "B"; Kameleoon may report the original as "Reference"/"Original", so anything but "B" is "a".
 * No variation at all (fallback, not allocated) stays null.
 */
export const toFlowzzFastDoctorApprovalArm = (variationName: string | null): string | null => {
  if (!variationName) return null;
  return variationName.trim().toLowerCase() === "b" ? "b" : "a";
};

const ChooseTreatmentRouter = () => {

  const { getSessionFields, setCartCurrency, updateCart } = useCartContext();
  const { headerVersion, setHeaderVersion, stickyNotification, setStickyNotification } = useAppContext();

  const { country, category, language } = useParams() as {
    country: string;
    category: string;
    language: string;
  };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(false);
  const [catalogSettings, setCatalogSettings] = useState<any>({});
  const [includeTreatmentFeeInPrice, setIncludeTreatmentFeeInPrice] =
    useState(true);
  const [isNoPrefereceTreatmentEnabled, setIsNoPrefereceTreatmentEnabled] =
    useState(false);

  const [showSubscriptionModal, setShowSubscriptionModal] = useState(true);
  const showSubscriptionModalCallback = (boolValue: boolean) => {
    setShowSubscriptionModal(boolValue);
  };

  const [showStickyNotification, setShowStickyNotification] = useState({
    show: false,
    title: "",
    content: "",
  });

  const handleErrorNotification = (title: string, content: string) => { 
    if (!title && !content) {
      setShowStickyNotification({ show: false, title: "", content: "" });
    } else {
      setShowStickyNotification({ show: true, title, content });
    }
  };

  const [allowPrescriptionForOutOfStock, setAllowPrescriptionForOutOfStock] = useState(false);
  const [layout, setLayout] = useState("");
  const [forceHidePrices, setForceHidePrices] = useState(false);
  const [showERezeptDisclaimer, setShowERezeptDisclaimer] = useState(false);
  const [shouldShowWalkthrough, setShouldShowWalkthrough] = useState<any>(null);

  const [searchParams] = useSearchParams();
  const redirectError = searchParams.get("ec"); //ec means error code

  const isByStockFlow = Boolean(searchParams.get("sc"));

  const [cartData,setCartData] = useState(null)
  const [isUrbifyEnabled, setIsUrbifyEnabled] = useState(false)
  const [urbifyOnboardingEligible, setUrbifyOnboardingEligible] = useState(false)


  const renderBasedOnLayout = () => {
    switch (layout) {
      case "new_customers":
        return <ChooseTreatmentLandingPage />;

      case "returning_customers":
        return <ReturningCustomersLayout />
        
      case ORDER_FLOWS.CANNALEO_PRE_SELECTED:
        return <CannaleoFreeDosageLayout />

      case "free_dosage_v2": //flow = multiple_products
        if (!isUrbifyEnabled) return <FreeDosageLayoutV2Legacy />;
        return <FreeDosageLayoutV2 />;

      case "care_plus": // HL-9781: WL Care+ treatment selection (catalog opts in via settings.layout)
        // HL-11360: the V3 treatment page with the in-page Choose Plan (V3 won the weight_loss_v3 test).
        return <ChooseTreatmentCarePlusNew />;

      default:
        return <ReturningCustomersLayout />;
    }
  }

  useEffect(() => {
    if (redirectError == "dnis") {
      setShowSubscriptionModal(false);
      handleErrorNotification(
        translator.translate(
          language,
          "default",
          "StickyNotification/danger_title"
        ),
        translator.translate(
          language,
          "default",
          "StickyNotification/product_not_in_stock"
        )
      );
    } else if (redirectError == "nss") {
      setShowSubscriptionModal(false);
      handleErrorNotification(
        translator.translate(
          language,
          "default",
          "StickyNotification/danger_title"
        ),
        translator.translate(
          language,
          "default",
          "StickyNotification/product_not_in_stock_for_subscription"
        )
      );
    } else if (redirectError == "npic") {
      setShowSubscriptionModal(false);
      handleErrorNotification(
        translator.translate(
          language,
          "default",
          "StickyNotification/product_not_in_cart_title"
        ),
        translator.translate(
          language,
          "default",
          "StickyNotification/product_not_in_cart_description"
        )
      );
      // When the user enters the payment page through a link, but the product is out of stock
    }else if (redirectError == "roos"){
      setShowSubscriptionModal(false);
      handleErrorNotification(
        translator.translate(
          language,
          "default",
          "StickyNotification/revive_out_of_stock_title"
        ),
        translator.translate(
          language,
          "default",
          "StickyNotification/revive_out_of_stock_description"
        )
      );
    }
  }, [redirectError]);

  // Set headerVersion based on category
  useEffect(() => {
    if (category === "medical_cannabis") {
      setHeaderVersion('v2');
    } else {
      setHeaderVersion('v1');
    }
  }, [category, setHeaderVersion]);

  // HL-11360: a page load straight onto /choose_plan (reload, an SSO return) restarts
  // the treatment flow here; `replace` drops the dead /choose_plan entry. HL-12294: reopenChoosePlan
  // reopens the in-page plan step for the product in the cart. HL-12777: /choose_plan renders this same
  // element, so browser Forward onto it keeps this page mounted and never reaches this mount-only redirect.
  useEffect(() => {
    if (!window.location.pathname.startsWith("/choose_plan/")) return;
    navigate(
      { pathname: `/select_treatment/${country}/${language}/${category}`, search: window.location.search },
      { replace: true, state: { reopenChoosePlan: true } },
    );
  }, []);

  useEffect(() => {


    let sessionCart = getSessionFields();
    if (!sessionCart?.mention || sessionCart?.mention !== category) {
      setLoading(false);
      window.eventsTracking.track({ e: "Auto navigation from CT", p: { ...sessionCart, category } });
      navigate({pathname: `/questionnaire/${country}/${language}/${getQuestionnaireMention(country, category)}`, search: searchParams.toString()});
    } else {

      //get the proper layout and catalog settings
      const epdParam = searchParams.get("epd");
      // HL-9738: echo any already-assigned service fee variant up on the GET so the server can
      // persist it on the cart. First visits have nothing stored; the server rolls one instead.
      const storedFeeVariant = localStorage.getItem(`abtest_${SERVICE_FEE_TEST_NAME}`);
      const query = new URLSearchParams();
      if (epdParam) query.set("epd", epdParam);
      // HL-11657: forward the campaign catalog_id so the server can resolve the dynamic-treatment-order
      // A/B variant (WL DE Care+) before this page's view event fires.
      const catalogIdParam = searchParams.get("catalog_id");
      if (catalogIdParam) query.set("catalog_id", catalogIdParam);
      // UK Care+ campaign links: the server resolves ?promote=<product mention> to a catalog id.
      const promoteParam = searchParams.get("promote");
      if (promoteParam) query.set("promote", promoteParam);
      if ((SERVICE_FEE_VARIANTS as readonly string[]).includes(storedFeeVariant ?? "")) {
        query.set("service_fee_test_variant", storedFeeVariant as string);
      }
      const buildRequestUrl = () => {
        const queryString = query.toString();
        return queryString
          ? `choose-treatment-settings/${category}/${country}/${language}?${queryString}`
          : `choose-treatment-settings/${category}/${country}/${language}`;
      };

      // HL-12814: every Flowzz Only Prescription user (af=flowzz) is in the Fast Doctor Approval A/B;
      // Kameleoon allocates when CT loads. The arm read here goes up with this GET and the server saves
      // it on the cart once (first write wins), so later loads reuse the cart's arm. Fallback (engine not
      // ready in 2 s, consent rejected, no variation): null => no arm sent, the server keeps the cart out
      // of the test and the page works as today. Once the server has echoed the cart's arm it is kept in
      // sessionStorage, so refreshes and back navigation send it straight away instead of waiting for Kameleoon.
      const isFlowzzFastDoctorApprovalEligible = searchParams.get("af") === FLOWZZ;
      const storedFlowzzArm = SessionStorageWrapper.getItem(`abtest_${FLOWZZ_FAST_DOCTOR_APPROVAL_TEST_NAME}`);
      const knownFlowzzArm = isFlowzzFastDoctorApprovalEligible && (FLOWZZ_FAST_DOCTOR_APPROVAL_VARIANTS as readonly string[]).includes(storedFlowzzArm ?? "")
        ? (storedFlowzzArm as string)
        : null;
      const flowzzFastDoctorApprovalArm = knownFlowzzArm
        ? Promise.resolve<string | null>(knownFlowzzArm)
        : isFlowzzFastDoctorApprovalEligible
          ? triggerExperiment("flowzz_fast_doctor_approval").then(toFlowzzFastDoctorApprovalArm)
          : Promise.resolve<string | null>(null);

      flowzzFastDoctorApprovalArm
        .then((arm) => {
          if (arm) query.set(FLOWZZ_FAST_DOCTOR_APPROVAL_TEST_NAME, arm);
          return http.getFromServer(buildRequestUrl(), [
            http.MIDDLEWARES.CUSTOMER_ID,
            http.MIDDLEWARES.CART_ORDER
          ]);
        })
        .then((response) => {
          // HL-9738: fire the Mixpanel page view FIRST, before any other logic can branch or throw,
          // so every successful load reliably emits exactly one PV carrying the server-resolved
          // service_fee_test variant. PageTracker skips select_treatment because it fires on route
          // change — ahead of this GET — and would drop the property. Only users rolled into the
          // test carry it (variant null otherwise).
          //
          // Care+ also uses this single PV (with funnel_type). Do NOT also fire
          // "View Choose Treatment Page" from useChooseTreatmentCarePlus — that double-count
          // inflated Questionnaire → Choose Treatment conversion toward ~100%.
          const resolvedFeeVariant = response.data.serviceFeeTestVariant;
          const serviceFeeVariant = (SERVICE_FEE_VARIANTS as readonly string[]).includes(resolvedFeeVariant ?? "")
            ? (resolvedFeeVariant as string)
            : null;
          // HL-12777: the default-product variant's catalog replaces the category default, and the
          // returning customer's last purchase rides along for the Care+ hook (empty for everyone else).
          const defaultProductCatalogId = assignDefaultProductVariant(response.data.defaultProductTest);
          // Same scope the server runs the test in (DE Care+): not enrolled now → drop an earlier group's properties.
          if (!defaultProductCatalogId && response.data.isCarePlus && country?.toLowerCase() === "de") {
            clearDefaultProductTrackingProps();
          }
          const catalogSettingsVar = {
            ...response.data.catalogSettings,
            ...(defaultProductCatalogId ? { ct_preselected_catalog_id: defaultProductCatalogId } : {}),
            last_purchased_product_item_ids: response.data.lastPurchasedProductItemIDs ?? [],
          };
          // HL-12814: the arm saved on the cart (server-side truth), only for carts in the test.
          const flowzzFastDoctorApprovalTestArm = (FLOWZZ_FAST_DOCTOR_APPROVAL_VARIANTS as readonly string[]).includes(response.data.fastDoctorApprovalFlowzzTestVariant ?? "")
            ? (response.data.fastDoctorApprovalFlowzzTestVariant as string)
            : null;

          assignOtcPopupVariant(response.data.otcPopupABTestWeights, { country, isCarePlus: response.data.isCarePlus });
          setContinueToShippingCategory(response.data.categoryMixpanelTitle ?? null);

          MainTracker.track("pv", "View Choose Treatment Page", {
            save_answer: getSaveAnswerVariant(),
            ...(serviceFeeVariant ? { service_fee_test: serviceFeeVariant } : {}),
            ...(flowzzFastDoctorApprovalTestArm ? { [FLOWZZ_FAST_DOCTOR_APPROVAL_TEST_NAME]: flowzzFastDoctorApprovalTestArm } : {}),
            ...getWlExperimentTrackingProps(),
            ...getFlowzzTrackingProps(),
            ...(defaultProductCatalogId ? getDefaultProductTrackingProps() : {}),
          });

          const cartData = response.data.cart;
          const shouldShowWalkthroughData = response.data.shouldShowWalkthrough;

          updateCart(cartData);

          // HL-9738: also mirror the variant into localStorage so the shipping page reads the same
          // value and the next choose-treatment load echoes it back via the query param.
          if (serviceFeeVariant) {
            localStorage.setItem(`abtest_${SERVICE_FEE_TEST_NAME}`, serviceFeeVariant);
          }
          if (flowzzFastDoctorApprovalTestArm) {
            SessionStorageWrapper.setItem(`abtest_${FLOWZZ_FAST_DOCTOR_APPROVAL_TEST_NAME}`, flowzzFastDoctorApprovalTestArm);
          }

          let isExternalPharmacyFlow = false;

          if (cartData.external_pharmacy_id) {
            isExternalPharmacyFlow = true;
          }

          if (cartData.countryCurrenciesByID) {
            setCartCurrency(cartData.countryCurrenciesByID[country?.toLowerCase()]);
          }
          
          setCartData(cartData);
          if (cartData.hide_prices) {
            setForceHidePrices(true);
          }

          if (cartData.allow_only_prescription) {
            setAllowPrescriptionForOutOfStock(true);
          }
          
          if (cartData.is_e_recipe) {
            setShowERezeptDisclaimer(true);
          }

          // Store walkthrough eligibility (set even if false to properly initialize state)
          setShouldShowWalkthrough(shouldShowWalkthroughData ?? false);
          setIsUrbifyEnabled(response.data.isUrbifyEnabled === true);
          setUrbifyOnboardingEligible(response.data.urbifyOnboardingEligible === true);


          if (isExternalPharmacyFlow && cartData.flow !== "multiple_products"){
            setLayout(ORDER_FLOWS.CANNALEO_PRE_SELECTED);
          } else if ((cartData.flow === "multiple_products" && catalogSettingsVar.layout === "free_dosage") || isByStockFlow) {
            setLayout("free_dosage_v2");
          } else {
            setLayout(catalogSettingsVar.layout);
          }
          
          setCatalogSettings(catalogSettingsVar);

          if (catalogSettingsVar.price_style === "no_treatment_fee") {
            setIncludeTreatmentFeeInPrice(false);
          }

          if (catalogSettingsVar.no_preference_medication){
            setIsNoPrefereceTreatmentEnabled(true);
          }

          SocialMediaTracker.track("pv", CHOOSE_TREATMENT_PAGE_VIEW_EVENT, {mention: category, searchParamas: Object.fromEntries(searchParams.entries())});

        })
        .catch((error) => {
          if (error?.response?.data?.logLevel) {
            window.clientLogger.error('error in getfromServer - ChooseTreatmentRouter', error);
          }
          setError(500);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);


  return (
    <>
{error && (
        <>
          <HeaderController showSteps={false} stage={"Questionnaire"} headerVersion={headerVersion} />
          <ServerError status={error} />
        </>
      )}


      {!error && showSubscriptionModal &&
        layout !== "care_plus" &&
        catalogSettings.subscription_view_type &&
        catalogSettings?.subscription_popup === 1 &&
        catalogSettings?.max_discount > 0 && !showERezeptDisclaimer ? (
        <SubscriptionModal
          showModalCallback={(boolValue: boolean) =>
            showSubscriptionModalCallback(boolValue)
          }
          language={language}
          country={country}
          discount={catalogSettings?.max_discount}
          ftd={99}
        />
      ) : null}

      {!loading && !error && (


        <RouterCartContext.Provider value={{ cartData }}>
          <SubscriptionModalContext.Provider
            value={{ showSubscriptionModalCallback }}
          >
            <CatalogSettingContext.Provider
              value={{
                includeTreatmentFeeInPrice,
                isNoPrefereceTreatmentEnabled,
                allowPrescriptionForOutOfStock,
                forceHidePrices,
                setShowStickyNotification,
                showERezeptDisclaimer,
                shouldShowWalkthrough,
                urbifyOnboardingEligible,
                ...catalogSettings,
              }}
            >
              <StickyNotification
                showNotification={showStickyNotification.show}
                title={showStickyNotification.title}
                onClick={(falseValue: any) => setShowStickyNotification(falseValue)}
                content={showStickyNotification.content}
                autoFade={true}
              />
              {
                renderBasedOnLayout()
              }
            </CatalogSettingContext.Provider>
          </SubscriptionModalContext.Provider>
        </RouterCartContext.Provider >

      )}

      {/* HL-12229: WL2 and WL3 (weight_loss_3 → weight_loss_2 via getCartMention) keep the questionnaire's branded loader instead of the green spinner. */}
      {/* HL-12357: V3 centres the loader on mobile. */}
      {loading && (getCartMention(category) === "weight_loss_2" ? (
        <LoadingPage language={language} centerContent />
      ) : (
        <LoadingModal />
      ))}
      {loading && (
        <StickyNotification
          showNotification={stickyNotification.show}
          title={stickyNotification.title}
          content={stickyNotification.content}
          level={stickyNotification.level}
          onClick={() => setStickyNotification({ ...stickyNotification, show: false })}
          showInfoIcon={stickyNotification.showInfoIcon}
          refresh={stickyNotification.refresh}
          autoFade={stickyNotification.autoFade}
        />
      )}
      </>
  );
};

export default ChooseTreatmentRouter;
